export default "__VITE_ASSET__RgHi$IMR__$_?url__"